import React, { Component } from "react";
import BigCalendar from "react-big-calendar";
import moment from "moment";
import Dialog from "material-ui/Dialog";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import FlatButton from "material-ui/FlatButton";
import TextField from "material-ui/TextField";
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TimePicker from "material-ui/TimePicker";
import UserService from "../../services/user.service";
import "../../App.css"
require("react-big-calendar/lib/css/react-big-calendar.css");


BigCalendar.momentLocalizer(moment);

class Calendar extends Component {
  constructor() {
    super();
    this.state = {
      events: [],
      _id: "",
      title: "",
      start: "",
      end: "",
      desc: "",
      repeating: 1,
      openSlot: false,
      openEvent: false,
      clickedEvent: {}
    };
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount(){
     // this.getCachedEvents();
     UserService.getCalendar("609b4bf6f61faa5dec87d76e").then(
      (response) => {
        console.log(response["events"]);
        const cal_events = response["events"];
        var calEvents = []
        cal_events.map((event) =>{
          if (event.repeating )
          {
            // const recurring_event = event;
            // recurring_event.start = new Date(recurring_event.start);
            // recurring_event.end = new Date(recurring_event.end);
            // console.log(recurring_event.title + "= "+recurring_event.start);
            // calEvents.push(recurring_event);
            for (var i = 0; i < event.repeating; i++)
            {
              
              const revent = new Object();
              revent.title = event.title;
            // alert(revent.start.getDate()+i*7);
              revent.start = new Date( this.addDays(event.start,7*i));
              // alert(revent.start);
              revent.end = new Date ( this.addDays(event.end,7*i));
              revent.repeating = event.repeating;
              revent._id = event._id;
              revent.desc = event.desc;
             // console.log(revent._id + ":"+revent.title + ": "+revent.start);
              
              calEvents.push(revent);
            }
            
            //alert(event.title);
          }
        });
        this.setState({events: calEvents})
        calEvents.map((event) =>{
          console.log(event._id + ":"+event.title + " @ "+event.start);
        });
      },
      (error) => {
        const _content = 
          (error.response && error.response) || 
          error.message ||
          error.toString();
        
      });

  }

  // getCachedEvents(){
  //   const cachedEvents = localStorage.getItem("cachedEvents");
  //   console.log("Cached Events", JSON.parse(cachedEvents));
  //   if(cachedEvents){
  //       this.setState({events: JSON.parse(cachedEvents)})
  //   }
  //   return;
  // }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  //closes modals
  handleClose() {
    this.setState({ openEvent: false, openSlot: false });
  }

  //  Allows user to click on calendar slot and handles if appointment exists
  handleSlotSelected(slotInfo) {
    console.log("Real slotInfo", slotInfo);
    this.setState({
      title: "",
      desc: "",
      repeating: 1,
      start: slotInfo.start,
      end: slotInfo.end,
      openSlot: true
    });
  }

  handleEventSelected(event) {
    console.log("event", event);
    this.setState({
      openEvent: true,
      clickedEvent: event,
      _id:event._id,
      start: event.start,
      end: event.end,
      title: event.title,
      desc: event.desc,
      repeating: event.repeating
    });
  }

  setTitle(e) {
    this.setState({ title: e });
  }

  setDescription(e) {
    this.setState({ desc: e });
  }

  setRepeating(e) {
    this.setState({ repeating: e });
  }
  handleStartTime = (event, date) => {
    this.setState({ start: date });
  };

  handleEndTime = (event, date) => {
    this.setState({ end: date });
  };

  // Onclick callback function that pushes new appointment into events array.
  setNewAppointment() {
    const { start, end, title, desc, repeating } = this.state;
    let appointment = { title, start, end, desc, repeating };
    console.log(appointment);
    let events = this.state.events.slice();
    events.push(appointment);
    //localStorage.setItem("cachedEvents", JSON.stringify(events));
    //add new event to database
    UserService.addCalEvent("609b4bf6f61faa5dec87d76e",title,start,end,desc,repeating);
    this.setState({ events });
  }

  //  Updates Existing Appointments Title and/or Description
  updateEvent() {
    const {_id, title, desc, start, end, repeating, events, clickedEvent } = this.state;
    console.log(clickedEvent);
    const index = events.findIndex(event => event === clickedEvent);
    const updatedEvent = events.slice();
    updatedEvent[index]._id = _id;
    updatedEvent[index].title = title;
    updatedEvent[index].desc = desc;
    updatedEvent[index].start = start;
    updatedEvent[index].end = end;
    updatedEvent[index].repeating = repeating;
    const newEvents = []
    events.map(p => 
      {
          if (p._id == _id)
          {
            p.title = title;
            p.desc = desc;
            p.repeating = repeating;
            var newStart = new Date(p.start);
            newStart.setHours((new Date(start)).getHours());newStart.setMinutes((new Date(start)).getMinutes());newStart.setSeconds((new Date(start)).getSeconds());

            var newEnd = new Date(p.end);
            newEnd.setHours((new Date(end)).getHours());newEnd.setMinutes((new Date(end)).getMinutes());newEnd.setSeconds((new Date(end)).getSeconds());
            p.start = newStart;
            p.end = newEnd;
           

          }
          newEvents.push(p);
      }
      
    );

    //localStorage.setItem("cachedEvents", JSON.stringify(updatedEvent));
    //update event in database
    
    UserService.updateCalEvent("609b4bf6f61faa5dec87d76e",_id,title,start,end,desc,repeating);
    this.setState({
      events: newEvents
    });
  }

  //  filters out specific event that is to be deleted and set that variable to state
  deleteEvent() {
    let updatedEvents = this.state.events.filter(
      event => event["start"] !== this.state.start
    );
    const {_id, title, desc, start, end, repeating, events, clickedEvent } = this.state;
    UserService.deleteCalEvent("609b4bf6f61faa5dec87d76e",_id);
    //alert(_id);
    //localStorage.setItem("cachedEvents", JSON.stringify(updatedEvents));
    this.setState({ events: updatedEvents });

    //delete event from database
  }

  render() {
    console.log("render()");
    const eventActions = [
      <FlatButton
        label="Cancel"
        primary={false}
        keyboardFocused={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Delete"
        secondary={true}
        keyboardFocused={true}
        onClick={() => {
          this.deleteEvent();this.handleClose();
        }}
      />,
      <FlatButton
        label="Confirm Edit"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleClose}
        onClick={() => {
          this.updateEvent();this.handleClose();
        }}
      />
    ];
    const appointmentActions = [
      <FlatButton label="Cancel" secondary={true} onClick={this.handleClose} />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={() => {
          this.setNewAppointment();this.handleClose();
        }}
      />
    ];
    return (
      <MuiThemeProvider >
      <div id="Calendar" className="App">
        {/* react-big-calendar library utilized to render calendar*/}
        <BigCalendar
          events={this.state.events}
          views={["month", "week", "day", "agenda"]}
          timeslots={2}
          defaultView="month"
          defaultDate={new Date()}
          selectable={true}
          onSelectEvent={event => this.handleEventSelected(event)}
          onSelectSlot={slotInfo => this.handleSlotSelected(slotInfo)}
        />

        {/* Material-ui Modal for booking new appointment */}
        <Dialog
          title={`Schedule an activity on ${moment(this.state.start).format(
            "MMMM Do YYYY"
          )}`}
          actions={appointmentActions}
          modal={false}
          open={this.state.openSlot}
          onRequestClose={this.handleClose}
        >
          <TextField
            floatingLabelText="Title"
            onChange={e => {
              this.setTitle(e.target.value);
            }}
          />
          <br />
          <TextField
            floatingLabelText="Description"
            onChange={e => {
              this.setDescription(e.target.value);
            }}
          />
          <TimePicker
            format="ampm"
            floatingLabelText="Start Time"
            minutesStep={5}
            value={this.state.start}
            onChange={this.handleStartTime}
          />
          <TimePicker
            format="ampm"
            floatingLabelText="End Time"
            minutesStep={5}
            value={this.state.end}
            onChange={this.handleEndTime}
          />
          <InputLabel id="label">Age</InputLabel>
          <Select labelId="label" id="select" value="20">
            <MenuItem value="10">Ten</MenuItem>
            <MenuItem value="20">Twenty</MenuItem>
          </Select>
     
          <br />
          <TextField
            floatingLabelText="Repeat"
            multiLine={false}
            defaultValue={this.state.repeating}
            onChange={e => {
              this.setRepeating(e.target.value);
            }}
          />
        </Dialog>

        {/* Material-ui Modal for Existing Event */}
        <Dialog
          title={`View/Edit Appointment of ${moment(this.state.start).format(
            "MMMM Do YYYY"
          )}`}
          actions={eventActions}
          modal={false}
          open={this.state.openEvent}
          onRequestClose={this.handleClose}
        >
          <TextField
            defaultValue={this.state.title}
            floatingLabelText="Title"
            onChange={e => {
              this.setTitle(e.target.value);
            }}
          />
          <br />
          <TextField
            floatingLabelText="Description"
            multiLine={true}
            defaultValue={this.state.desc}
            onChange={e => {
              this.setDescription(e.target.value);
            }}
          />
          <TimePicker
            format="ampm"
            floatingLabelText="Start Time"
            minutesStep={5}
            value={this.state.start}
            onChange={this.handleStartTime}
          />
          <TimePicker
            format="ampm"
            floatingLabelText="End Time"
            minutesStep={5}
            value={this.state.end}
            onChange={this.handleEndTime}
          />

          <br />
          <TextField
            floatingLabelText="Repeat"
            multiLine={false}
            defaultValue={this.state.repeating}
            onChange={e => {
              this.setRepeating(e.target.value);
            }}
          />
        </Dialog>
      </div>
      </MuiThemeProvider>
    );
    
  }
}

export default Calendar;
